import { ClimaproData } from './portal';

export enum AlertType {
	Maintenance = 'maintenance',
	Itv = 'itv',
	Delivery = 'delivery',
	Bonus = 'bonus',
}
export interface Vehicle {
	id: number;
	vehicleClimaproId: number;
	frame: string;
	image: string;
	comercialDenomination: string;
	commercialDenominationSli: string;
	familyModelCode: string;
	familyModelDesc: string;
	tmaimg: string | null;
	license: string | null;
	modelYear: string;
	dealerDate: number;
	licenseDate: number | null;
	deliveryDate: number;
	climaproKm: number;
	localKM: number;
	alertNextMaintenance: boolean;
	alertPreITV: boolean;
	alertEntregaIdeal: boolean;
	status: VehicleStatus;
	typeDescription: string;
	mediaAssets: VehiclesMediaAssets;
	flagIsVO: boolean;
	longdrive: VehicleLongdrive | null;
	warranty: VehicleWarranty;
	orderCode?: string;
	orderDate?: number;
}

export interface VehicleWithAlerts extends Vehicle {
	alertType: AlertType;
}

export enum VehicleStatus {
	'READY' = 'READY',
	'TO_BE_CONFIRMED' = 'TO_BE_CONFIRMED',
	'TO_BE_CREATED' = 'TO_BE_CREATED',
	'TO_BE_DELETED' = 'TO_BE_DELETED',
	'DELETED' = 'DELETED',
	'ORDER' = 'ORDER',
}

export type VehiclesMediaAssets = {
	Back_Left: string;
	Back_Right: string;
	Front_Center: string;
	Front_Left: string;
	Front_Right: string;
	Interior_Center_Center: string;
	Interior_Lhd_Center: string;
	Interior_Rhd_Center: string;
	Interior_Seat: string;
	Interior_Side: string;
	Side_Left: string;
	Side_Right: string;
	Wheel: string;
};

export type DataVehicles = {
	identitykitId: string;
	climapro: ClimaproData;
	vehicles: Vehicle[];
	orders: Vehicle[];
};

export enum ErrorType {
	NonDefined = 'Non defined',
	ConfirmVehicle = 'Confirm vehicle',
	AddVehicle = 'Add vehicle',
	AddVehicleClub = 'Add vehicle Club',
	DeleteVehicle = 'Delete vehicle',
	ConfirmData = 'Confirm frame and license',
}

export type VehicleWarranty = {
	// Status garantia general en general
	flagVNGarantia?: boolean;
	flagVNGarantiaExtendida?: boolean;
	isWarrantyExtension?: boolean; //(DUPLICADO)
	warrantyEndingDate?: number | string;

	// Garantia fabricante:
	anyosCoberturaGarantia?: number;

	// Extensión garantía:
	flagHiredWarrantyExtension?: boolean;
	warrantyExtensionYears?: number;
	warrantyCoverageKms?: number;
	codPRExtensionGarantia?: string;
};

export type VehicleLongdrive = {
	id: number;
	contractCode: string;
	contractDate: number | string;
	contractStartDate: number | string;
	contractEndDate: number | string;
	frame: string;
	contractType?: string;
	typeCode: string;
	saleTypeCode: string;
	isBundle: boolean;
	productDesc: string;
	contractedKms: number;
	climaproPersonId: number;
	codPaquete: string;
	product: LongdriveProduct;
	isPro: boolean;
};

enum LongdriveProduct {
	'VOLKSWAGEN LONG DRIVE STANDARD' = 'Standard',
	'VOLKSWAGEN LONG DRIVE ADVANCE' = 'Advance',
	'VOLKSWAGEN LONG DRIVE NEUMÁTICOS' = 'Pro',
}
